import { Filter, TextInput } from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  textInput: { 
    width: 400, 
    marginRight: 10,
    border: 'none'
},
}))

const SearchFilter = (props) => {
  const classes = useStyles()

  return (
    <Filter {...props}>
      <TextInput label='Search' source='q' alwaysOn className={classes.textInput} placeholder='Search in logs...' />
    </Filter>
  )
}

export default SearchFilter
